export default "__VITE_ASSET__4de0d4a2__"